import { render } from "./RenderAssetIcons.vue?vue&type=template&id=76d4cc5d"
import script from "./RenderAssetIcons.vue?vue&type=script&lang=js"
export * from "./RenderAssetIcons.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__